<template>
  <div class="guests-filter">
    <form-counter :id="0" class="counter" label="Adults (13+)" :set-value="getAdults" :min="children > 0 || infants > 0 ? 1 : 0" :max="getMaxAdults" @value="onCounterClicked($event,'adults')" />
    <form-counter :id="1" class="counter" label="Children (3 - 12)" :set-value="getChildren" :min="0" :max="getMaxChildren" @value="onCounterClicked($event,'children')" />
    <form-counter :id="2" class="counter" label="Infants (0 - 2)" :set-value="getInfants" :min="0" :max="maxInfants" @value="onCounterClicked($event,'infants')" />
    <div v-if="infants > 0" class="info-txt">
      <span class="bold">2</span> Infants can be included and do not go towards the full house capacity.
    </div>
  </div>
</template>

<script>
import { _ } from 'vue-underscore';
import Bus from '../../../events/bus';
import cfg from '../../../config/config';
import responsive from '../../../mixins/responsive';
import FormCounter from '../../../components/FormCounter.vue';

const add = (...args) => args.reduce((acc, val) => acc + val, 0);

// Data to be shared across multiple instances
const srcdata = {
  people: 0,
  adults: 0,
  children: 0,
  infants: 0,
  maxAdults: cfg.PriceConfigMaxAllowables.People,
  maxChildren: cfg.PriceConfigMaxAllowables.People,
  maxInfants: cfg.PriceConfigMaxAllowables.ExtraBabies,
};

export default {
  name: 'Guests',
  components: {
    FormCounter,
  },
  mixins: [responsive],
  props: {
    id: { type: Number, default: 3 },
  },
  data: () => srcdata,
  computed: {
    currentCollectionList() {
      return this.$store.getters['pages/getCollectionData'];
    },
    isResultsPage() {
      return this.$store.getters['pages/currentPage'] ? this.$store.getters['pages/currentPage'].templateId == 5 : false;
    },
    getMaxAdults() {
      this.maxAdults = cfg.PriceConfigMaxAllowables.People - this.children;
      return this.maxAdults;
    },
    getMaxChildren() {
      this.maxChildren = cfg.PriceConfigMaxAllowables.People - this.adults;
      return this.maxChildren;
    },
    getTotalPeople() {
      return this.infants > 2 ? (this.adults + this.children + (this.infants - 2)) : this.adults + this.children;
    },
    getAdults() {
      return this.adults;
    },
    getChildren() {
      return this.children;
    },
    getInfants() {
      return this.infants;
    },
  },
  mounted() {
    Bus.$on('restoreFilterFromStore', this.restoreFilterFromStore);
    Bus.$on('restoreFilterFromURL', this.restoreFilterFromURL);
    Bus.$on('restoreFilterFromCookies', this.restoreFilterFromCookies);
    Bus.$on('resetGuests', this.reset);
    Bus.$on('resetOccupancy', this.reset);
    Bus.$on('selectPeopleFilter', this.selectPeopleFilter);
    Bus.$emit('filterMounted', 'guests');
    if (!this.isResultsPage) {
      this.restoreFilterFromCookies();
    }
  },
  beforeDestroy() {
    Bus.$off('restoreFilterFromStore', this.restoreFilterFromStore);
    Bus.$off('restoreFilterFromURL', this.restoreFilterFromURL);
    Bus.$off('restoreFilterFromCookies', this.restoreFilterFromCookies);
    Bus.$off('resetGuests', this.reset);
    Bus.$off('resetOccupancy', this.reset);
    Bus.$off('selectPeopleFilter', this.selectPeopleFilter);
  },
  methods: {
    restoreFilterFromStore() {
      this.people = this.$store.getters['results/getPeople'];
      this.restoreGuests();
    },
    restoreFilterFromURL() {
      if (this.$route.query.people && this.$route.query.people > 0) {
        this.people = Number(this.$route.query.people);
        this.restoreGuests();
      }
    },
    restoreFilterFromCookies() {
      if (!this.currentCollectionList && window.$cookies.get('people')) {
        this.people = window.$cookies.get('people');
        this.restoreGuests();
      }
    },
    restoreGuests() {
      this.adults = Number(window.$cookies.get('adults') ? window.$cookies.get('adults') : this.$store.getters['guests/getAdults']);
      this.children = Number(window.$cookies.get('children') ? window.$cookies.get('children') : this.$store.getters['guests/getChildren']);
      this.infants = Number(window.$cookies.get('infants') ? window.$cookies.get('infants') : this.$store.getters['guests/getInfants']);

      if (this.people != this.getTotalPeople) {
        this.adults = this.people;
        this.children = 0;
        this.infants = 0;
      }

      this.storeValues();
      this.filterProperties(true);
    },

    selectPeopleFilter(value, isRestore = true) {
      this.people = Number(value);
      this.adults = this.people;
      this.children = this.infants = 0;
      this.storeValues();
      this.filterProperties(isRestore);
    },
    onCounterClicked(value, name) {
      this[name] = value;
      this.people = this.getTotalPeople;
      this.checkValues();
      this.storeValues();
      this.isResultsPage ? this.debounceFilterProperties(false) : null;
    },
    checkValues() {
      if (this.adults == 0) {
        if (this.children > 0 || this.infants > 0) {
          this.adults = 1;
          this.people = this.adults + this.children;
        }
      }
    },
    storeValues() {
      this.$store.commit('results/setPeople', this.people);
      this.$store.commit('guests/setAdults', this.adults);
      this.$store.commit('guests/setChildren', this.children);
      this.$store.commit('guests/setInfants', this.infants);

      if (!this.currentCollectionList) {
        window.$cookies.set('people', this.people, cfg.neverExpire);
        window.$cookies.set('adults', this.adults, cfg.neverExpire);
        window.$cookies.set('children', this.children, cfg.neverExpire);
        window.$cookies.set('infants', this.infants, cfg.neverExpire);
      }
    },
    debounceFilterProperties: _.debounce(function (isRestore) {
      this.filterProperties(isRestore);
    }, 600),
    filterProperties(isRestore) {
      if (this.isResultsPage) {
        this.$router.replace({ query: { ...this.$route.query, people: this.people && this.people > 0 ? this.people : undefined } });
        if (!isRestore) {
          Bus.$emit('filterProperties', 'select people');
        }
      }
    },
    reset(isRestore) {
      this.resetValues();
      this.$router.replace({ query: { ...this.$route.query, people: undefined } });
      !isRestore ? Bus.$emit('filterProperties', 'clear People') : null;
    },
    resetValues() {
      this.people = this.adults = this.children = this.infants = 0;
      window.$cookies.set('people', '');
      window.$cookies.set('adults', '');
      window.$cookies.set('children', '');
      window.$cookies.set('infants', '');
      this.$store.commit('results/setPeople', 0);
      this.$store.commit('guests/setAdults', 0);
      this.$store.commit('guests/setChildren', 0);
      this.$store.commit('guests/setInfants', 0);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/styles/settings/config.scss";

.counter{
    margin: 20px 0px 20px 0;
}

.info-txt{
    font-family: $font-family-grotesk;
    color: $darkBlack;
    font-size: 14px;
    font-weight: 400;
    margin:20px 0 0;
    line-height: 1.1;
}

</style>
